import {
  FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  WebWidth,
  WebLeft,
  CSP,
} from "../../config/config";
import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_MASTERCATEGORY,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  STORE_PROMO_PRODUCT_LIST,
  STORE_DineType,
} from "../../database/store-names";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_LoadProductListToMobileAppForAnMID } from "../../connection/api/api-product-list";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { GET_CART, GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { set_dto_MobileAppCategory } from "../../classes/dto-setters/dto-setter";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { SET_STORE_DINE_TYPE } from "../../database/store-data";
import { dto_common } from "../../classes/dto-common";
import { F_Fammily } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import QuickCartButton from "./components/quick-cart-button/quick-cart-button";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import PlaceHolder from "./components/product-list-place-holder/product-list-place-holder";
import Category from "./components/product-lisit-category/product_list_category";
import ItemView from "./components/product-list-item/product-list-item";
import React from "react";
import "../../styles/css/pg-product-list.css";
import "../../styles/css/fixedbutton.css";
import "../../styles/css/animate.css";
var $ = require("jquery");
const cloneDeep = require("lodash.clonedeep");

export default class PromoProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CateList: [],
      PrdList: [],
      inMemoryProducts: [],
      isLoading: true,
      displayMessage: false,
      desc: "",
      DrawerIsOpen: false,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: 0,
      LocalCart: [],
      IsSummaryCart: false,
      ActiveIndex: 0,
      PaddingLeft: "14%",
      DelPaddingLeft: "17%",
      MainTopMargin: "0px",
      iconDisplay: "block",
      deliveryDisabled: false,
      takeawayDisabled: false,
      MerchantData: [],
      filterText: "",
      IsFavourite: false,
      SwitchCategory: false,
      CategoryList: [],
      isz2a: true,
      showSortDropDown: false,
      showDropdown: false,
      selectedCategoryLabel: "Category",
    };
    this.lastTouchTs = 0;
    this.categoryTouchMoved = false;
    this.categoryTouchStart = null;
    this.keepCheckInterval = null;
    this.lastCartSignature = "";
  }

  getCartSignature = (cart = []) =>
    cart
      .map(
        (item) =>
          `${item.PID}:${item.LineID}:${item.ADDONLINEID}:${item.Qty}:${item.UP}`,
      )
      .join("|");

  refreshLocalCart = async () => {
    let cart = await GET_CART();
    if (cart === undefined) {
      cart = [];
    }

    const nextSignature = this.getCartSignature(cart);
    if (nextSignature !== this.lastCartSignature) {
      this.lastCartSignature = nextSignature;
      this.setState({ LocalCart: cart });
    }
  };

  handleCategoryTouchStart = (event) => {
    if (!event.touches || !event.touches[0]) {
      return;
    }
    this.categoryTouchMoved = false;
    this.categoryTouchStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  };

  handleCategoryTouchMove = (event) => {
    if (!this.categoryTouchStart || !event.touches || !event.touches[0]) {
      return;
    }
    const dx = event.touches[0].clientX - this.categoryTouchStart.x;
    const dy = event.touches[0].clientY - this.categoryTouchStart.y;
    if (Math.hypot(dx, dy) > 8) {
      this.categoryTouchMoved = true;
    }
  };

  handleCategorySelect = async (event, cate, i) => {
    if (event && event.type === "touchend") {
      this.categoryTouchStart = null;
      if (this.categoryTouchMoved) {
        return;
      }
      this.lastTouchTs = Date.now();
      event.preventDefault();
    } else if (Date.now() - this.lastTouchTs < 500) {
      return;
    }

    set_dto_MobileAppCategory(cate);
    this.setState({ showDropdown: false });
    dto_selected_merchant_or_product.CATID = cate.CATID;

    if (cate.CATID === 0) {
      this.setState({ PrdList: [] });
      localStorage.setItem("isAllCat", true);
      let firstCATID = this.state.CategoryList[1].CATID;
      dto_selected_merchant_or_product.CATID = firstCATID;
      this.setState({ PrdList: [] });
    } else {
      localStorage.setItem("isAllCat", false);
      this.setState({ PrdList: [] });
    }

    await this.loadSubProduct(cate.Category);
    const categoryText = cate.Category;
    const truncatedText =
      categoryText.length > 20 ? categoryText.slice(0, 20) + "..." : categoryText;
    this.setState({
      isLoading: false,
      selectedCategoryLabel: truncatedText || "Category",
    });

    setTimeout(() => {
      document.getElementById("SelectedCat").innerText = truncatedText;

      const container = document.getElementById(
        "horizontalCategoryScrollContainer"
      );
      const categoryItems = container ? container.children : [];
      const activeItem = categoryItems[i];

      if (container && activeItem) {
        const containerWidth = container.offsetWidth;
        const itemOffset = activeItem.offsetLeft;
        const itemWidth = activeItem.offsetWidth;
        const scrollTo = itemOffset - containerWidth / 2 + itemWidth / 2;

        container.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });
      }
      this.scrollToTarget("1SECTIONS", 105);
    }, 100);
  };

  async componentDidMount() {
    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
    if (CSP === "MK") {
      this.setState({ SwitchCategory: false });
      localStorage.setItem("isAllCat", false);
    }
    if (CSP === "DT") {
      if (dto_selected_merchant_or_product.Merchant === "MKB Supermarket") {
        localStorage.setItem("isAllCat", false);
        ENCRYPT_STORAGE.removeItem(STORE_PROMO_PRODUCT_LIST);
      } else {
        dto_selected_merchant_or_product.CATID = 0;
      }
    }
    await GET_SET_STORED_DATA();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: dto_selected_merchant_or_product.Merchant,
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_MASTERCATEGORY);
      },
      HeaderNavigatorMenuDisplay: true,
      FnHeaderNavigatorMenu: () => {
        this.TransformationFillterTextBox();
      },
    });

    await this.LoadProduct();
    await this.LoadMasterCategory();
    await api_DaitonnAnalytical();
    await this.Setdinetype();
    this.setState({
      selectedCategory: "OFFER",
      selectedCategoryLabel: "OFFER",
    });

    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
      this.lastCartSignature = this.getCartSignature(cart);
    }
    this.keepCheckInterval = setInterval(() => {
      this.refreshLocalCart();
    }, 750);
  }

  async keepCheck() {
    await this.refreshLocalCart();
  }

  async componentWillUnmount() {
    clearInterval(this.keepCheckInterval);
    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
  }

  getScrollContainer = () => {
    if (isMobile) {
      return (
        document.querySelector(".body-container") ||
        document.scrollingElement ||
        document.documentElement ||
        document.body
      );
    }

    return (
      document.querySelector(".WindowDevice") ||
      document.scrollingElement ||
      document.documentElement ||
      document.body
    );
  };

  scrollToTarget = (targetId, offset = 105) => {
    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    const container = this.getScrollContainer();
    if (!container) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const isDocumentContainer =
      container === document.body ||
      container === document.documentElement ||
      container === document.scrollingElement;

    if (isDocumentContainer) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const nextTop =
      container.scrollTop + (targetRect.top - containerRect.top) - offset;

    container.scrollTo({
      top: Math.max(0, nextTop),
      behavior: "smooth",
    });
  };

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  focusSearchInput = () => {
    setTimeout(() => {
      const input = document.getElementById("InputproductlistFilterTextBox");
      if (input) {
        input.focus();
      }
    }, 50);
  };

  async Setdinetype() {
    let DineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
    const hasDineType = !Number.isNaN(DineType);
    let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
    const MerchantDetails =
      dataStorage?.MerchantData ||
      this.state.MerchantData ||
      dto_selected_final_merchant_or_product ||
      dto_selected_merchant_or_product;

    if (
      MerchantDetails === undefined ||
      MerchantDetails === null ||
      Number.isNaN(Number(MerchantDetails?.MID))
    ) {
      return;
    }

    let SelectedMerchantDineType = Number(MerchantDetails.DineType);

    if (!hasDineType) {
      if (SelectedMerchantDineType === 0) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
        this.setState({ ActiveIndex: 0 });
      }
      if (SelectedMerchantDineType === 4) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
      } else if (SelectedMerchantDineType === 3) {
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
      }
    } else {
      if (SelectedMerchantDineType === 4 && DineType !== 4) {
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
      if (SelectedMerchantDineType === 3 && DineType !== 3) {
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 4 && DineType === 4) {
        this.setState({
          ActiveIndex: 0,
          takeawayDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
      if (SelectedMerchantDineType === 3 && DineType === 3) {
        this.setState({
          ActiveIndex: 1,
          deliveryDisabled: true,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 0 && DineType === 3) {
        this.setState({
          ActiveIndex: 1,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(3);
        }
      }
      if (SelectedMerchantDineType === 0 && DineType === 4) {
        this.setState({
          ActiveIndex: 0,
        });
        if (
          dto_selected_final_merchant_or_product.MID === MerchantDetails.MID
        ) {
          SET_STORE_DINE_TYPE(4);
        }
      }
    }
  }

  sortProducts = (sortType) => {
    let ProductListt = this.state.CateList;
    let PromoProductList = ProductListt[0];
    let PrdList = JSON.parse(PromoProductList.dtoProductSessionList);

    switch (sortType) {
      case "A_TO_Z":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
        break;

      case "Z_TO_A":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameB.localeCompare(nameA);
        });
        break;

      case "PRICE_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceA - priceB;
        });
        break;

      case "PRICE_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceB - priceA;
        });
        break;

      case "DISCOUNT_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentA - discountPercentB;
        });
        break;

      case "DISCOUNT_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentB - discountPercentA;
        });
        break;

      default:
        break;
    }

    PromoProductList.dtoProductSessionList = JSON.stringify(PrdList);
    ProductListt[0] = PromoProductList;
    this.setState({ CateList: ProductListt, showSortDropDown: false });

    if (isMobile) {
      $("html,body").animate({ scrollTop: 10 }, 700);
    } else {
      $(".WindowDevice").animate({ scrollTop: 10 }, 700);
    }
  };

  async TransformationFillterTextBox() {
    var element = document.getElementsByClassName("transform");
    element[0].classList.add("transform-active-fillter-product");
    $(".productlistFilterTextBox").fadeIn(1000);
    this.focusSearchInput();

    let overlay = document.querySelector(".shadow-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "shadow-overlay";
      document.body.appendChild(overlay);
    }

    const headerHeight = document.getElementById("DivHeaderHome").offsetHeight;
    overlay.style.top = `${headerHeight}px`;

    overlay.style.width = isMobile ? "100%" : `${WebWidth}px`;
    overlay.style.left = isMobile ? 0 : WebLeft;

    overlay.style.display = "block";
    overlay.addEventListener("click", () => {
      $(".productlistFilterTextBox").fadeOut(800);
      element[0].classList.remove("transform-active-fillter-product");
      this.setState({
        PrdList: this.state.inMemoryProducts,
        CateList: this.state.inMemoryProducts,
        displayMessage: false,
      });
      overlay.style.display = "none";
    });

    FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS({
      FnFilterTextBox: (e) => {
        this.InputproductlistFilterTextBoxOnChange(e);
      },
      FnFilterCloseButton: (e) => {
        if (element) {
          element[0].classList.remove("transform-active-fillter-product");
          $(".productlistFilterTextBox").fadeOut(800);
          this.setState({
            PrdList: this.state.inMemoryProducts,
            CateList: this.state.inMemoryProducts,
            displayMessage: false,
          });
          overlay.style.display = "none";
        }
      },
      FnFilterClearButton: (e) => {
        this.setState((state) => {
          const PrdList = [...this.state.inMemoryProducts];
          const CateList = [...this.state.inMemoryProducts];
          const displayMessage = false;
          return {
            PrdList,
            CateList,
            displayMessage,
          };
        });
      },
    });
  }

  async LoadMasterCategory() {
    let catdata = await api_CategoryPageLoadGroceryCategory();
    let catobjData = JSON.parse(catdata);

    let data = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
    let objData = data.PromoProductList;
    let objectArray = JSON.parse(objData[0].dtoProductSessionList);

    let uniqueCAValues = [...new Set(objectArray.map((item) => item.CA))];
    let filteredCategories = [
      catobjData[0],
      ...catobjData.filter(
        (cat, index) => index !== 0 && uniqueCAValues.includes(cat.Category)
      ),
    ];

    this.setState({ CategoryList: filteredCategories });
  }

  async LoadApiProduct() {
    let data = await api_LoadProductListToMobileAppForAnMID();
    let ObjData = JSON.parse(data);
    let PromoProductList = ObjData[0];
    let ProductListt;
    if (
      (CSP === "MK" && dto_selected_merchant_or_product.CATID !== 1) ||
      (CSP === "DT" &&
        dto_selected_merchant_or_product.Merchant === "MKB Supermarket" &&
        dto_selected_merchant_or_product.CATID !== 1)
    ) {
      let withoutOffer = PromoProductList.filter(
        (item) => item.Category !== "OFFER"
      );
      ProductListt = withoutOffer;
    } else {
      ProductListt = PromoProductList;
    }
    let MerchantDataa = ObjData[1];
    this.setState({ MerchantData: MerchantDataa });
    ENCRYPT_STORAGE.removeItem(STORE_PROMO_PRODUCT_LIST);
    ENCRYPT_STORAGE.setItem(STORE_PROMO_PRODUCT_LIST, {
      PromoProductList: ProductListt,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      date: new Date(),
      CATID: dto_selected_merchant_or_product.CATID,
    });
    return ProductListt;
  }

  async LoadProduct() {
    try {
      this.setState({ isLoading: true });
      let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
      let data = "";
      if (dataStorage !== undefined && dataStorage !== "") {
        if (dataStorage.MID === dto_selected_merchant_or_product.MID) {
          let StorageDateTime = new Date(dataStorage.date);
          let currentDateTime = new Date();
          let DifferenceMinute = DIFERENCE_MINUTES(
            currentDateTime,
            StorageDateTime
          );
          if (DifferenceMinute > 1) {
            ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
            data = await this.LoadApiProduct();
          } else {
            if (
              dto_selected_merchant_or_product.MT === "GR" ||
              dto_selected_merchant_or_product.MT === "AF" ||
              CSP === "MK"
            ) {
              if (
                dataStorage.CATID === dto_selected_merchant_or_product.CATID
              ) {
                data = dataStorage.PromoProductList;
                this.setState({ MerchantData: dataStorage.MerchantData });
              } else {
                ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                data = await this.LoadApiProduct();
              }
            } else {
              data = dataStorage.PromoProductList;
              this.setState({ MerchantData: dataStorage.MerchantData });
            }
          }
        } else {
          ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
          data = await this.LoadApiProduct();
        }
      } else {
        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
        data = await this.LoadApiProduct();
      }

      let Localcart = await GET_CART();
      if (Localcart === undefined) {
        Localcart = [];
      }

      this.setState(
        {
          CateList: data,
          PrdList: data,
          inMemoryProducts: data,
          isLoading: false,
          LocalCart: Localcart,
        },
        () => {}
      );

      setTimeout(async () => {
        if (!this.state.isLoading) {
          await this.ScrollIndicaterMenu();
        }
      }, 500);

      setTimeout(() => {
        let PID = ENCRYPT_STORAGE_SESSION.getItem("PrdIdScroll");
        if (PID !== undefined) {
          if (isMobile) {
            $("html,body").animate(
              {
                scrollTop: $("#" + PID)[0].offsetTop - 110,
              },
              500
            );
          } else {
            $(".WindowDevice").animate(
              {
                scrollTop: $("#" + PID)[0].offsetTop - 110,
              },
              500
            );
          }
        } else {
          if (isMobile) {
            $("html,body").animate(
              {
                scrollTop: 10,
              },
              0
            );
          } else {
            $(".WindowDevice").animate(
              {
                scrollTop: 10,
              },
              0
            );
          }
        }
      }, 100);
      setTimeout(() => {
        let cateSection = document.getElementById("cateSection");
        if (cateSection) {
          cateSection.style.display = "none";
        }
      }, 50);
    } catch (error) {
      console.error("LoadProductList : " + error);
    }
  }

  async loadSubProduct(SelectedCat) {
    try {
      this.setState({ isLoading: true, selectedCategory: SelectedCat });

      dto_selected_merchant_or_product.CATID = 1;
      let prdlist = await this.LoadApiProduct();
      let objPrdList = JSON.parse(prdlist[0].dtoProductSessionList);
      let filteredList = objPrdList;
      if (SelectedCat !== "OFFER") {
        filteredList = objPrdList.filter((item) => item.CA === SelectedCat);
      }
      let data = JSON.stringify(filteredList);
      prdlist[0].dtoProductSessionList = data;

      this.setState({
        PrdList: prdlist,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error loading sub-products:", error);
    }
  }

  async ScrollIndicaterMenu() {
    let ItemSection = document.getElementsByClassName("ItemList");
    let CateSection = document.getElementsByClassName("btnCategorys");

    let element;
    if (isMobile) {
      element = document.querySelector(".body-container");
    } else {
      element = document.querySelector(".WindowDevice");
    }

    // Function to scroll category into view horizontally
    const scrollCategoryIntoView = (categoryName) => {
      const container = document.getElementById(
        "horizontalCategoryScrollContainer"
      );
      if (!container) return;

      const categoryItems = container.children;
      let activeIndex = -1;

      // Find the active category index
      for (let i = 0; i < categoryItems.length; i++) {
        const categoryText = categoryItems[i].textContent.trim();
        if (categoryText === categoryName.toUpperCase()) {
          activeIndex = i;
          break;
        }
      }

      // Scroll the active category into view
      if (activeIndex !== -1 && categoryItems[activeIndex]) {
        const containerWidth = container.offsetWidth;
        const itemOffset = categoryItems[activeIndex].offsetLeft;
        const itemWidth = categoryItems[activeIndex].offsetWidth;

        // Calculate scroll position to center the item
        const scrollTo = itemOffset - containerWidth / 2 + itemWidth / 2;

        container.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });
      }
    };

    // Initial scroll to show the selected category on page load
    setTimeout(() => {
      const currentSelectedCategory = this.state.selectedCategory;
      if (currentSelectedCategory) {
        scrollCategoryIntoView(currentSelectedCategory);
      }
    }, 200);

    element.removeEventListener("scroll", this.handleScroll);
    this.handleScroll = async () => {
      for (let i = 0; i < ItemSection.length; i++) {
        let top = element.scrollTop;
        let offset = ItemSection[i].offsetTop - 120;
        let Height = ItemSection[i].offsetHeight;
        let ID = ItemSection[i].id;
        let ScrollToTopBTN = document.getElementById("ScrollToTopBTN");

        if (top > 252) {
          $("#cateSection").show(500);
        } else {
          $("#cateSection").hide(500);
        }

        if (top > 1630) {
          ScrollToTopBTN.style.display = "none";
        } else {
          ScrollToTopBTN.style.display = "none";
        }

        if (top >= offset && top < offset + Height) {
          if (CSP === "MK" || CSP === "DT") {
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            const truncatedText =
              CategoryName.length > 20
                ? CategoryName.slice(0, 20) + "..."
                : CategoryName;

            // Update the selected category text
            document.getElementById("SelectedCat").innerText = truncatedText;
            this.setState({
              selectedCategoryLabel: truncatedText || "Category",
            });

            // Auto-scroll the horizontal category list to show the active category
            scrollCategoryIntoView(CategoryName);

            // Update the selectedCategory state
            this.setState({ selectedCategory: CategoryName });

            if (
              CSP === "MK" ||
              (CSP === "DT" &&
                dto_selected_merchant_or_product.Merchant === "MKB Supermarket")
            ) {
              let SelectedCATID = dto_selected_merchant_or_product.CATID;
              const isScrolledToBottom =
                element.scrollTop + element.clientHeight >=
                element.scrollHeight;
              let CategoryList = this.state.CategoryList;
              let isAllCat = localStorage.getItem("isAllCat");

              if (isScrolledToBottom && isAllCat === "true") {
                if (CategoryList && CategoryList.length > 0) {
                  const index = CategoryList.findIndex(
                    (item) => item.CATID === SelectedCATID
                  );

                  if (index !== -1 && index < CategoryList.length - 1) {
                    const nextCATID = CategoryList[index + 1].CATID;
                    SelectedCATID = dto_selected_merchant_or_product.CATID =
                      nextCATID;

                    await this.loadSubProduct(CategoryList.Category);
                  }
                }
              }
            }
          }

          for (let c = 0; c < CateSection.length; c++) {
            if (CateSection[c].classList[0] === ID) {
              CateSection[c].style.color = "white";
              CateSection[c].style.backgroundColor = Colors.DarkGreyScale;

              var scrollTo = CateSection[c].offsetLeft;
              var xd = $("#cateSection");
              xd[0].scrollLeft = scrollTo - 3;
            } else {
              CateSection[c].style.color = "black";
              CateSection[c].style.backgroundColor = Colors.LightGreyScale;
            }
          }
        }
      }
    };
    element.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  handleFilterChange = (e) => {
    const filterText = e.target.value;
    this.setState({ filterText });
    this.filterProductList(filterText.toLowerCase());

    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
  };

  showOverlay = () => {
    let overlay = document.querySelector(".shadow-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "shadow-overlay";
      document.body.appendChild(overlay);
    }

    overlay.style.top = "45px";
    overlay.style.width = isMobile ? "100%" : `${WebWidth}px`;
    overlay.style.left = isMobile ? 0 : WebLeft;
    overlay.style.position = "fixed";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0,0,0,0.5)";
    overlay.style.zIndex = "1000";
    overlay.style.display = "block";

    overlay.onclick = () => {
      $("#NewFilterationTextBox").fadeOut(500);
      overlay.style.display = "none";
      this.resetFilter();
    };
  };

  filterProductList = (filterText) => {
    const filteredCateList = this.state.inMemoryProducts
      .map((category) => {
        const filteredProducts = JSON.parse(
          category.dtoProductSessionList
        ).filter((product) => product.D.toLowerCase().includes(filterText));
        return {
          ...category,
          dtoProductSessionList: JSON.stringify(filteredProducts),
        };
      })
      .filter(
        (category) => JSON.parse(category.dtoProductSessionList).length > 0
      );

    this.setState({
      CateList: filteredCateList,
      PrdList: filteredCateList,
      displayMessage: filteredCateList.length === 0,
    });
  };

  resetFilter = () => {
    this.setState({
      CateList: this.state.inMemoryProducts,
      PrdList: this.state.inMemoryProducts,
      displayMessage: false,
      filterText: "",
    });
  };

  handleCancelClick = () => {
    $("#NewFilterationTextBox").animate(
      {
        height: "toggle",
      },
      500,
      () => {
        this.resetFilter();
        const overlay = document.querySelector(".shadow-overlay");
        if (overlay) {
          overlay.style.display = "none";
        }
        $("#NewFilterationTextBox").hide();
      }
    );
  };

  InputproductlistFilterTextBoxOnChange(e) {
    let item = [];
    let IsFiltered = false;
    let TempItems = cloneDeep(this.state.inMemoryProducts);
    TempItems.forEach((rs) => {
      let lIstArrayPrd = [];
      let products = JSON.parse(rs.dtoProductSessionList);

      products.filter((prd) => {
        let isMatch = prd.D.toLowerCase().includes(
          e.currentTarget.value.toLowerCase()
        );
        if (isMatch) {
          IsFiltered = true;
          lIstArrayPrd.push(prd);
        }
        return isMatch;
      });

      rs.dtoProductSessionList = JSON.stringify(lIstArrayPrd);
      item.push(rs);
    });
    if (IsFiltered) {
      this.setState({
        PrdList: item,
        CateList: item,
        displayMessage: false,
      });
    } else {
      this.setState({
        PrdList: item,
        CateList: item,
        displayMessage: true,
      });
    }
  }

  render() {
    return (
      <div
        id="OnScrollProdcutList"
        style={{
          marginBottom: 55,
          marginTop:
            CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
              ? "44px"
              : this.state.MainTopMargin,
        }}
      >
        <div
          id="NewFilterationTextBox"
          className="fadeInBottom cssanimation"
          style={{
            display: "none",
            position: "absolute",
            paddingTop: "5px",
            top: 0,
            height: 50,
            width: "100%",
            zIndex: 1800,
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* textbox */}
            <input
              className="productlistFilterTextBox"
              type="text"
              style={{
                width: "90%",
                height: 50,
                border: "none",
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                paddingLeft: "8px",
              }}
              value={this.state.filterText}
              placeholder="Filter Items"
              id="InputproductlistFilterTextBox"
              onChange={this.handleFilterChange}
            />

            {/* circle close */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderRight: "1px solid gray",
                color: "#a1a1a1",
                backgroundColor: "#fff",
                padding: "7px",
              }}
              id="btnproductlistFilterTextBoxclear"
              onClick={this.resetFilter}
            >
              <i className="bi bi-x-circle-fill" />
            </button>

            {/* cancel */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                backgroundColor: "white",
                fontFamily: F_Fammily.Medium,
                fontWeight: "600",
              }}
              id="btnproductlistFilterTextBoxClsoe"
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>

        {this.state.isLoading ? (
          <PlaceHolder />
        ) : (
          <>
            <div
              style={{
                display:
                  CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                    ? "none"
                    : "block",
              }}
            >
              {/* Parent div with relative positioning */}
              <div style={{ position: "relative" }}>
                <img
                  src={this.state.MerchantData.IL}
                  style={{ width: "100%", height: 180, objectFit: "cover" }}
                  alt={this.state.MerchantData.IL}
                />

                {/* Back Icon */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "5px",
                    fontSize: 24,
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  onClick={() => {
                    if (dto_selected_merchant_or_product.MT === "RS") {
                      if (this.props.params.navPage === "home-filter") {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "home")
                        );
                      } else {
                        this.props.navigate(PT_HOME);
                      }
                    } else {
                      this.props.navigate(PT_MASTERCATEGORY);
                    }
                  }}
                >
                  <i className="bi bi-arrow-left" />
                </div>

                {/* Search Icon */}
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    top: "10px",
                    right: "5px",
                    fontSize: 24,
                    color: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  id="HeaderNavigatorBoostrapIcon"
                  onClick={() => {
                    $("#NewFilterationTextBox").fadeIn(500);
                    this.showOverlay();
                    this.focusSearchInput();
                  }}
                >
                  <i className="bi bi-search" />
                </div>
              </div>

              {/* Merchant Info Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 5px",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    display: CSP === "DT" || CSP === "MK" ? "none" : "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-shop" style={{ paddingRight: "8px" }} />
                  {this.state.MerchantData.Merchant}
                </div>

                <div
                  style={{
                    display: this.state.MerchantData.AR > 0 ? "flex" : "none",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-hand-thumbs-up-fill" />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {" "}
                    {this.state.MerchantData.AR}%
                  </span>
                </div>
              </div>
            </div>

            {this.state.CateList.length !== 0 ? (
              <div>
                <div
                  style={{
                    backgroundColor: "white",
                    position: "fixed",
                    left: isMobile ? 0 : WebLeft,
                    width: isMobile ? "100%" : WebWidth,
                    right: 0,
                    zIndex: 1500,
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    overflowY: "hidden",
                    padding: 5,
                    top: 48,
                    display: CSP === "MK" ? "block" : "none",
                  }}
                  id={CSP === "MK" ? "" : "cateSection"}
                >
                  <div>
                    {/* HORIZONTAL CATEGORY */}
                    <div
                      id="horizontalCategoryScrollContainer"
                      style={{
                        padding: "10px",
                        display: "flex",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {this.state.CategoryList.map((cate, i) => {
                        return (
                          <div
                            key={"dropdownKey" + i + cate.CATID}
                            style={{
                              backgroundColor:
                                this.state.selectedCategory === cate.Category
                                  ? Colors.DarkGreyScale
                                  : Colors.LightGreyScale,
                              color:
                                this.state.selectedCategory === cate.Category
                                  ? "white"
                                  : Colors.DarkGreyScale,
                              border: "1px solid #474747",
                              fontWeight: "bold",
                              fontSize: "14px",
                              padding: "5px 12px",
                              whiteSpace: "normal",
                              flex: "0 0 auto",
                              marginRight: "10px",
                              borderRadius: "6px",
                              textAlign: "center",
                            }}
                            onClick={(event) =>
                              this.handleCategorySelect(event, cate, i)
                            }
                            onTouchStart={this.handleCategoryTouchStart}
                            onTouchMove={this.handleCategoryTouchMove}
                            onTouchEnd={(event) =>
                              this.handleCategorySelect(event, cate, i)
                            }
                          >
                            {cate.Category.toUpperCase()}
                          </div>
                        );
                      })}
                    </div>

                    {/* CATEGORY HEADER */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "10% 75% 15%",
                        alignItems: "center",
                      }}
                    >
                      {/* Left - Menu Icon */}
                      <i
                        className="bi bi-list"
                        style={{
                          fontSize: 18,
                          borderRadius: "18px",
                          marginLeft: "6px",
                          marginRight: "6px",
                          color: "white",
                          padding: "3px 4px",
                          backgroundColor: "rgba(0, 0, 0, 0.8)",
                          justifySelf: "start", // Optional
                        }}
                        onClick={() =>
                          this.setState({
                            showDropdown: !this.state.showDropdown,
                          })
                        }
                      />

                      {/* Center - Header */}
                      <h1
                        id="SelectedCat"
                        style={{
                          fontSize: 24,
                          fontFamily: F_Fammily.Medium,
                          margin: 0,
                          fontWeight: "bold",
                          wordWrap: "break-word",
                          color: "black",
                          padding: "5px",
                          textAlign: "center",
                        }}
                      >
                        {this.state.selectedCategoryLabel}
                      </h1>

                      <i
                        className="bi bi-funnel"
                        style={{
                          fontSize: 18,
                          borderRadius: "18px",
                          marginLeft: "6px",
                          marginRight: "6px",
                          color: "white",
                          padding: "3px 4px",
                          backgroundColor: "rgba(0, 0, 0, 0.8)",
                          justifySelf: "end",
                        }}
                        onClick={() =>
                          this.setState({
                            showSortDropDown: true,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="container"
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: CSP === "MK" ? 90 : 0,
                  }}
                >
                  <div>
                    {this.state.PrdList.map &&
                      this.state.PrdList.map((cate, i) => {
                        let PrdList = [];
                        PrdList = JSON.parse(cate.dtoProductSessionList);
                        if (PrdList.length > 0) {
                          return (
                            <div
                              className="ItemList"
                              id={cate.CATID + "SECTIONS"}
                              key={cate.CATID + "PromoProductList" + i + "Key"}
                            >
                              <div
                                className="row"
                                key={cate.CATID + i + "Key"}
                                style={{ display: "block" }}
                              >
                                <Category
                                  Category={cate.Category.toUpperCase()}
                                  ID={cate.CATID}
                                  key={
                                    cate.CATID + "CategoryHeading" + i + "Key"
                                  }
                                />
                              </div>
                              <div className="" key={i + cate.CATID + "PRD"}>
                                {PrdList.map((item, i) => {
                                  return (
                                    <>
                                      <ItemView
                                        onClick={async (rs, index) => {
                                          await Api_DrawAnalyticalPath(1, rs);
                                          ENCRYPT_STORAGE_SESSION.setItem(
                                            "PrdIdScroll",
                                            rs + "PRD" + index
                                          );
                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list"
                                            )
                                            .replace(
                                              ":navigatepage",
                                              "product-list"
                                            )
                                            .replace(
                                              ":category",
                                              cate.Category.replace(
                                                "/",
                                                "-"
                                              ).toLowerCase()
                                            )
                                            .replace(":pid", rs)
                                            .replace(":lineid", 1)
                                            .replace(":adonlineid", 1)
                                            .replace(":isrecommended", 0)
                                          );
                                        }}
                                        goToProduct={(rs) => {
                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list"
                                            )
                                              .replace(
                                                ":navigatepage",
                                                "product-list"
                                              )
                                              .replace(
                                                ":category",
                                                cate.Category.replace(
                                                  "/",
                                                  "-"
                                                ).toLowerCase()
                                              )
                                              .replace(":pid", rs.PI)
                                              .replace(":lineid", 1)
                                              .replace(":adonlineid", 1)
                                              .replace(":isrecommended", 0)
                                          );
                                        }}
                                        key={item.PI + "PromoProductList" + i}
                                        pid={item.PI}
                                        data={item}
                                        index={i}
                                        Description={item.D}
                                        GenDesc={item.G}
                                        SP={item.P}
                                        UD={item.UD}
                                        IsAvailable={item.A}
                                        ProductImage={
                                          <div className="">
                                            {item.IU !== "" &&
                                            item.IU !== "N/A" ? (
                                              <img
                                                style={{
                                                  height: 70,
                                                  width: 70,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                }}
                                                loading="lazy"
                                                id={"prdImageLise" + item.PI}
                                                src={item.IU.split("λ")[0]}
                                                alt=""
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: 30,
                                                  width: 30,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                  filter: "grayscale(100%)",
                                                  WebkitFilter:
                                                    "grayscale(100%)",
                                                }}
                                                src={dto_common.DefaultImageUrl}
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                                alt=""
                                              />
                                            )}
                                          </div>
                                        }
                                      />
                                      <div
                                        style={{
                                          borderTop: "1px solid black",
                                          transform: "scaleY(0.1)",
                                          display: "block",
                                        }}
                                      />
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>

                  {this.state.displayMessage ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "200px",
                        height: "100vh",
                      }}
                    >
                      <img
                        src={require("./images/NoDataFound.jpg")}
                        width={"60%"}
                        alt=""
                      />

                      <label
                        style={{
                          fontWeight: "bold",
                          marginBottom: "8px",
                          textAlign: "center",
                        }}
                      >
                        We did not find a match
                      </label>
                      <label style={{ textAlign: "center" }}>
                        Try searching for something instead
                      </label>

                      <div
                        style={{
                          display: CSP === "MK" ? "block" : "none",
                          backgroundColor: Colors.DarkGreyScale,
                          borderRadius: "4px",
                          color: "white",
                          marginTop: "40px",
                          padding: "4px 8px",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          this.props.navigate(
                            PT_FILTER_OUTLETS_PRODUCTS.replace(
                              ":frmpath",
                              "category"
                            )
                          );
                          let filterText = document.getElementById(
                            "InputproductlistFilterTextBox"
                          ).value;
                          ENCRYPT_STORAGE.setItem(
                            "SearchStringFilter",
                            filterText
                          );
                        }}
                      >
                        Find More at Other <br />
                        Categories
                      </div>
                    </div>
                  ) : null}
                  {!this.state.displayMessage && CSP === "MK" ? (
                    <div
                      style={{
                        backgroundColor: Colors.DarkGreyScale,
                        borderRadius: "4px",
                        color: "white",
                        margin: "24px auto 0",
                        padding: "4px 8px",
                        textAlign: "center",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "category"
                          )
                        );
                        let filterText = document.getElementById(
                          "InputproductlistFilterTextBox"
                        ).value;
                        ENCRYPT_STORAGE.setItem(
                          "SearchStringFilter",
                          filterText
                        );
                      }}
                    >
                      Find More at Other <br />
                      Categories
                    </div>
                  ) : null}
                </div>

                {dto_selected_merchant_or_product.MT !== "RS" ? (
                  <button
                    id="CategoryBTN"
                    style={{
                      left: isMobile ? "80%" : "63%",
                    }}
                    onClick={() => {
                      $("#DisplayCateList").show(400);
                    }}
                  >
                    <i className="bi bi-list" style={{ fontSize: 28 }} />
                  </button>
                ) : (
                  ""
                )}
                {!this.state.displayMessage ? (
                  <button
                    id="ScrollToTopBTN"
                    title="Go to top"
                    style={{ left: isMobile ? "80%" : "63%" }}
                    onClick={() => {
                      if (isMobile) {
                        $("html,body").animate(
                          {
                            scrollTop: 10,
                          },
                          700
                        );
                      } else {
                        $(".WindowDevice").animate(
                          {
                            scrollTop: 10,
                          },
                          700
                        );
                      }
                    }}
                  >
                    <i
                      className="bi bi-arrow-up-square"
                      style={{ fontSize: 28 }}
                    />
                  </button>
                ) : null}

                {/* View Basket For View Cart */}
                {this.state.LocalCart.length > 0 
                // &&
                // (CSP === "MK" || CSP === "DT") 
                ? 
                (
                  <QuickCartButton
                    totalPrice={this.getTotalPrice()}
                    itemCount={this.state.LocalCart.length}
                    onClick={async () => {
                      let Localcart = await GET_CART();
                      if (Localcart === undefined) {
                        Localcart = [];
                      }
                      this.setState(
                        { IsSummaryCart: true, LocalCart: Localcart },
                        async () => {
                          await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(
                            async () => {
                              let Localcart = await GET_CART();
                              if (Localcart === undefined) {
                                Localcart = [];
                              }
                              this.setState({
                                IsSummaryCart: false,
                                LocalCart: Localcart,
                              });
                            },
                          );
                        },
                      );
                    }}
                  />
                ) : null}

              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "70px",
                  height: "100vh",
                }}
              >
                <img
                  src={require("./images/NoDataFound.jpg")}
                  width={"60%"}
                  alt=""
                />

                <label
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                    textAlign: "center",
                  }}
                >
                  We did not find a match
                </label>
                <label style={{ textAlign: "center" }}>
                  Try searching for something instead
                </label>
              </div>
            )}
          </>
        )}

        {dto_selected_merchant_or_product.MT !== "RS" ? (
          <div
            id="DisplayCateList"
            style={{
              position: "fixed",
              zIndex: 4600,
              left: 0,
              top: 0,
              width: "100%",
              height: "100%",
              overflow: "auto",
              display: "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
            onClick={() => {
              $("#DisplayCateList").hide(400);
            }}
          >
            <div
              style={{
                width: 230,
                height: 300,
                position: "fixed",
                zIndex: 3500,
                bottom: 200,
                right: 80,
                backgroundColor: "white",
                padding: 3,
                overflow: "auto",
              }}
            >
              {this.state.CateList.map((rs, i) => {
                if (rs.dtoProductSessionList !== "[]") {
                  return (
                    <div
                      key={rs.CATID + "Modal" + i}
                      style={{ display: "flex" }}
                      onClick={() => {
                        if (isMobile) {
                          $("html,body").animate(
                            {
                              scrollTop: $("#" + rs.CATID)[0].offsetTop - 105,
                            },
                            1000
                          );
                        } else {
                          $(".WindowDevice").animate(
                            {
                              scrollTop: $("#" + rs.CATID)[0].offsetTop - 105,
                            },
                            1000
                          );
                        }
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          borderBottom: "0.5px solid #ecf0f1",
                          padding: 5,
                          width: "85%",
                          fontSize: 12,
                        }}
                      >
                        {rs.Category.toUpperCase()}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          width: "15%",
                          padding: 5,
                          paddingLeft: 10,
                        }}
                      >
                        <i className="bi bi-arrow-right-circle" />
                      </p>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </div>
        ) : (
          ""
        )}

        <DrawerSheetBottom
          open={this.state.showDropdown}
          closeFunction={() => this.setState({ showDropdown: false })}
          displayCloseIcon="block"
          element={
            <div style={{ position: "relative", height: "100%" }}>
              <div
                style={{
                  maxHeight: "calc(100% - 70px)",
                  overflowY: "auto",
                }}
              >
                {this.state.CategoryList.map((cate, i) => {
                  return (
                    <div
                      key={"dropdownKey" + i + cate.CATID}
                      style={{
                        padding: "12px 12px",
                        cursor: "pointer",
                        fontSize: "16px",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={() => this.handleCategorySelect(null, cate, i)}
                    >
                      {cate.Category.toUpperCase()}
                    </div>
                  );
                })}
              </div>

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ showDropdown: false })}
              >
                {" "}
                Dismiss{" "}
              </button>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Categories"
        />

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          closeFunction={() => this.setState({ IsSummaryCart: false })}
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0)
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({
                  LocalCart: updatedCart,
                  IsSummaryCart: updatedCart.length > 0,
                });
              }}
              closeFunction={() => this.setState({ IsSummaryCart: false })}
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />

        <DrawerSheetBottom
          open={this.state.showSortDropDown}
          closeFunction={() => this.setState({ showSortDropDown: false })}
          element={
            <div>
              {/* A-Z */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("A_TO_Z")}
              >
                <i
                  className="bi bi-sort-alpha-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort A - Z
                </span>
              </div>
              <br />

              {/* Z-A */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("Z_TO_A")}
              >
                <i
                  className="bi bi-sort-alpha-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort Z - A
                </span>
              </div>
              <br />

              {/* Price Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-numeric-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price low to high
                </span>
              </div>
              <br />

              {/* Price High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-numeric-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price high to low
                </span>
              </div>
              <br />

              {/* Discount Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % low to high
                </span>
              </div>
              <br />

              {/* Discount High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % high to low
                </span>
              </div>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Sort Products"
        />
      </div>
    );
  }
}
